import { triggerNotifications } from "../Helpers/helperMessages";
import { callsTodayModel, unavailablesHistoryModel } from "../mappers/models.mapper";
import { Logger } from '../logging/Logger';
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
export const getSvrUnavailablesHistory = (sdkResource, userID) => {
    let objectResponse = sdkResource.apiCont.getObjectResponse();
    sdkResource.apiCont.getNotReadyHistory(userID, objectResponse);
    objectResponse.onError = function (messageError) {
        const code = messageError.InternalCode;
        const message = that.language.getText(`${type.toLowerCase()}-${code}`);
        const type = messageError.Type;
        console.log("[AgentSDK] [unavailablesHistory] [Error]: "+messageError);
        triggerNotifications(sdkResource, code, type, MESSAGE_FROM.CW, message);
        Logger.Error('[getNotReadyHistory] Error consulting DataBase ', message);
        sdkResource.errorEvents.errorReceivedUnavailablesHistory([]);
    };
    objectResponse.onSuccess = function (objResponse) {
        console.log("[AgentSDK] [unavailablesHistory]: Object from server received. Processing...");
        const historyModel = unavailablesHistoryModel(objResponse.Response);
        sdkResource.svrEvents.onReceivedUnavailablesHistory(historyModel);
        triggerNotifications(sdkResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
    };
}

export const getSvrCallsHistory = (sdkResource, userID, requestTimeout) => {
    let objectResponse = sdkResource.apiCont.getObjectResponse();
    sdkResource.apiCont.callHistory(userID, objectResponse, requestTimeout);
    objectResponse.onError = function (messageError) {
        const code = messageError.InternalCode;
        const message = that.language.getText(`${type.toLowerCase()}-${code}`);
        const type = messageError.Type;
        console.log("[AgentSDK] [callsHistory] [Error]: "+messageError);
        triggerNotifications(sdkResource, code, type, MESSAGE_FROM.CW, message);
        Logger.Error('[callHistory] Error consulting DataBase ', message);
        sdkResource.errorEvents.errorReceivedCallsHistory([]);
    };
    objectResponse.onSuccess = function (objResponse) {
        console.log("[AgentSDK] [unavailablesHistory]: Object from server received. Processing...");
        const historyModel = callsTodayModel(objResponse.CallHistoryList);
        sdkResource.svrEvents.onReceivedCallsToday(historyModel);
        triggerNotifications(sdkResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
    };
}